import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Attribute } from 'src/app/models/attribute';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormLabelService {



  url = environment.serverAPI4 + "/api/dynamicformlabel";

  constructor(private http: HttpClient) { }

  getdynamicFormLabel(Page: any, size: any, sort: any ,typeId: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`);
  }

  getAllDynamicFormDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getDynamicFormId(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditDynamic(dynamic: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, dynamic);
  }

  dynamicFormLabelSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteByAttributId(fieldId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${fieldId}`);
  }

  productNotLinked(linkedDynamic, Page: number, size: number, sort: any, typeId:any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/linked?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`, linkedDynamic);
  }

  productNotLinkedSearch(linkedDynamic, Page: number, size: number, sort: any,typeId:any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}/linked/search?page=${Page}&size=${size}&sort=${sort}&typeId=${typeId}`, linkedDynamic);
  }

  getDynmaicForm(formGroupId:any): Observable<Object> {
    return this.http.get(`${this.url}/label/${formGroupId}`);
		
	}

}